import { createSlice } from '@reduxjs/toolkit';
import { regionInstanceApi } from '../services';
import { RootState } from './index';
import { MY_ACCOUNT_LIST, UPGRADE_STATE } from '../utils/helper';
import { InstanceActionConst, InstanceActionName } from '../config';
interface IAccount {
  instance_state: Record<string, any>;
}

const initialState: IAccount = {
  instance_state: { [MY_ACCOUNT_LIST]: {} }
};

const instanceStateSlice = createSlice({
  name: 'instanceState',
  initialState,
  reducers: {
    // updateInstanceState: (state, { payload }) => {
    //   const account_id = payload?.account_id;
    //   const group_id = payload?.group_id || MY_ACCOUNT_LIST;
    //   if (account_id) {
    //     const group = state.instance_state[group_id] || {};
    //     state.instance_state[group_id] = {
    //       ...group,
    //       [account_id]: {
    //         showUpgrade: !!payload?.state,
    //         state: payload?.state,
    //         action: payload?.action
    //       }
    //     };
    //   }
    // }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      regionInstanceApi.endpoints.getInstanceExtraInfo.matchFulfilled,
      (state, { payload, meta }) => {
        const { arg } = meta;
        const account_id = arg?.originalArgs?.account?.account_id;
        const group_id =
          arg?.originalArgs?.account?.group_id || MY_ACCOUNT_LIST;
        if (account_id) {
          const group = state.instance_state[group_id] || {};
          const version_upgrade = payload?.version_upgrade;
          if (
            version_upgrade &&
            version_upgrade?.state === UPGRADE_STATE.NEED_UPGRADE
          ) {
            state.instance_state[group_id] = {
              ...group,
              [account_id]: {
                ...payload,
                state: version_upgrade?.state || null,
                showUpgrade: true
              }
            };
          }
        }
      }
    );
    builder.addMatcher(
      regionInstanceApi.endpoints.getInstanceState.matchFulfilled,
      (state, { payload, meta }) => {
        const { arg } = meta;
        const account_id = arg?.originalArgs?.accountIds?.[0];
        const group_id = arg?.originalArgs?.groupId || MY_ACCOUNT_LIST;
        const action = arg?.originalArgs?.action;
        const status = payload?.status;
        if (account_id) {
          const group = state.instance_state[group_id] || {};
          state.instance_state[group_id] = {
            ...group,
            [account_id]: {
              state: status,
              action: action,
              actionName:
                action && InstanceActionName[action]
                  ? InstanceActionName[action]
                  : ''
            }
          };
        }
      }
    );
    builder.addMatcher(
      regionInstanceApi.endpoints.getInstByAccount.matchFulfilled,
      (state, { payload }) => {
        const account_id = payload?.account_id;
        const instance = payload?.data || {};
        const filterStatus = [
          'SUCCESS',
          'ERROR',
          'UPGRADE_SUCCESS',
          'UPGRADE_ERROR'
        ];
        const upgradeState =
          instance.version_upgrade &&
          !filterStatus.includes(instance.version_upgrade?.state)
            ? instance.version_upgrade?.state
            : '';
        const snapshotState =
          instance.snapshot_status &&
          !filterStatus.includes(instance.snapshot_status)
            ? instance.snapshot_status
            : '';
        const revertState =
          instance.revert_status &&
          !filterStatus.includes(instance.revert_status)
            ? instance.revert_status
            : '';
        const status = upgradeState || snapshotState || revertState;
        if (account_id && status) {
          const group_id = payload?.group_id || MY_ACCOUNT_LIST;
          const group = state.instance_state[group_id] || {};
          const action = upgradeState
            ? InstanceActionConst.upgrade
            : snapshotState
            ? InstanceActionConst.createSnapshot
            : InstanceActionConst.revertSnapshot;
          state.instance_state[group_id] = {
            ...group,
            [account_id]: {
              state: status,
              action: action,
              showUpgrade: !!upgradeState,
              actionName:
                action && InstanceActionName[action]
                  ? InstanceActionName[action]
                  : ''
            }
          };
        }
      }
    );
  }
});

const { reducer, actions } = instanceStateSlice;
// export const { updateInstanceState } = actions;

export const selectInstancesStateInfo = (state: RootState) =>
  state.instanceState?.instance_state;

export default reducer;
